import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { DropdownFilterWcagComponent, HeaderMenuItemComponent } from './advanced';
import { AccountActionsSelectorComponent } from './advanced/account-actions-selector/account-actions-selector.component';
import { AccountNavigationComponent } from './advanced/account-navigation/account-navigation.component';
import { AddCardFormComponent } from './advanced/add-card-form/add-card-form.component';
// import { DropdownFilterComponent, SelectableListComponent } from './advanced';
import { CalendarControlsComponent } from './advanced/calendar/calendar-controls/calendar-controls.component';
import { CalendarDayComponent } from './advanced/calendar/calendar-day/calendar-day.component';
import { CalendarWeekComponent } from './advanced/calendar/calendar-week/calendar-week.component';
import { CalendarComponent } from './advanced/calendar/calendar.component';
import { CardActionsSelectorComponent } from './advanced/card-actions-selector/card-actions-selector.component';
import { CarouselComponent, CarouselItemElement } from './advanced/carousel/carousel.component';
import { DatePeriodSelectorComponent } from './advanced/date-period-selector/date-period-selector.component';
import { DatepickerComponent } from './advanced/datepicker/datepicker.component';
import { DatepickerFeatureComponent } from './advanced/datepicker-feature/datepicker-feature.component';
import { DialogBottomComponent } from './advanced/dialog/dialog-footer/dialog-bottom/dialog-bottom.component';
import { DialogComponent } from './advanced/dialog/dialog.component';
import { DropdownFilterComponent } from './advanced/dropdown-filter/dropdown-filter.component';
import { DropdownDefaultItemComponent } from './advanced/dropdown/dropdown-default-item/dropdown-default-item.component';
import { DropdownRelatedCardItemComponent } from './advanced/dropdown/dropdown-related-card-item/dropdown-related-card-item.component';
import { DropdownComponent } from './advanced/dropdown/dropdown.component';
import { FormFieldModule } from './advanced/form-field/form-field.module';
import { LanguageSelectorComponent } from './advanced/language-selector/language-selector.component';
import { LoginSocialComponent } from './advanced/login-social/login-social.component';
import { LoginComponent } from './advanced/login/login.component';
import { ModalWrapperComponent } from './advanced/modal-wrapper/modal-wrapper.component';
import { ModalComponent } from './advanced/modal/modal.component';
import { ProgressV2Component } from './advanced/progress-v2/progress-v2.component';
import { ProgressComponent } from './advanced/progress/progress.component';
import { RadioGroupComponent } from './advanced/radio-group/radio-group.component';
import { RegisterSocialComponent } from './advanced/register-social/register-social.component';
import { RegisterComponent } from './advanced/register/register.component';
import { SelectableButtonComponent } from './advanced/selectable-button/selectable-button.component';
import { SelectableItemsComponent } from './advanced/selectable-items/selectable-items.component';
import { SelectableListComponent } from './advanced/selectable-list/selectable-list.component';
import { TableComponent } from './advanced/table/table.component';
import { TabsComponent } from './advanced/tabs/tabs.component';
import { TermsAndConditionsBlockComponent } from './advanced/terms-and-conditions-block/terms-and-conditions-block.component';
import { TermsModalContentComponent } from './advanced/terms-modal-content/terms-modal-content.component';
import { ArrowDownSeparatorComponent } from './basic/arrow-down-separator/arrow-down-separator.component';
import { BlockFullWidthFormsComponent } from './basic/block-full-width-forms/block-full-width-forms.component';
import { BlockFullWidthMessageComponent } from './basic/block-full-width-message/block-full-width-message.component';
import { BlockFullWidthComponent } from './basic/block-full-width/block-full-width.component';
import { BlockItemsThreeComponent } from './basic/block-items-three/block-items-three.component';
import { BlockItemsTwoComponent } from './basic/block-items-two/block-items-two.component';
import { BlockLeftSidePanelComponent } from './basic/block-left-side-panel/block-left-side-panel.component';
import { BlockRightSidePanelComponent } from './basic/block-right-side-panel/block-right-side-panel.component';
import { BlockRowAreaResponsiveComponent } from './basic/block-row-area-responsive/block-row-area-responsive.component';
import { BlockRowAreaComponent } from './basic/block-row-area/block-row-area.component';
import { BlockRowItemsComponent } from './basic/block-row-items/block-row-items.component';
// import { IconButtonComponent, IconComponent, SimpleListItemComponent } from './basic';
import { BlockRowComponent } from './basic/block-row/block-row.component';
import { ButtonComponent } from './basic/button/button.component';
import { IconButtonComponent } from './basic/icon-button/icon-button.component';
import { IconComponent } from './basic/icon/icon.component';
import { InputFloatingLabelErrorComponent } from './basic/input-floating-label-error/input-floating-label-error.component';
import { InputFloatingLabelComponent } from './basic/input-floating-label/input-floating-label.component';
import { NavigationBarComponent } from './basic/navigation-bar/navigation-bar.component';
import { PageContentWrapperComponent } from './basic/page-content-wrapper/page-content-wrapper.component';
import { SelectableBlockWrapperComponent } from './basic/selectable-block-wrapper/selectable-block-wrapper.component';
import { SelectableCheckableItemComponent } from './basic/selectable-checkable-item/selectable-checkable-item.component';
import { SelectableItemComponent } from './basic/selectable-item/selectable-item.component';
import { SelectableListItemComponent } from './basic/selectable-list-item/selectable-list-item.component';
import { SimpleListItemComponent } from './basic/simple-list-item/simple-list-item.component';
import { TabItemComponent } from './basic/tab-item/tab-item.component';
import { TableHeaderComponent } from './basic/table-header/table-header.component';
import { TableRowComponent } from './basic/table-row/table-row.component';
import { VerticalOrSeparatorComponent } from './basic/vertical-or-separator/vertical-or-separator.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { CarouselItemDirective } from './directives/carousel-item.directive';
import { FocusInvalidInputDirective } from './directives/focus-invalid-input.directive';
import { MatchHeightDirective } from './directives/match-height.directive';
import { MswTileComponent } from './generic/msw/msw-tile/msw-tile.component';
import { MswComponent } from './generic/msw/msw.component';
import { TermsDialogModule } from './advanced/terms-dialog/terms-dialog-module';
import { TranslatedLinkHandlerDirective } from './directives/translated-link-handler.directive';
import { RidangoScrollIntoViewDirective } from './directives/scroll-into-view.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        FormFieldModule,
        TranslateModule,
        A11yModule,
        BrowserAnimationsModule,
        MatIconModule,
        TermsDialogModule
    ],
    declarations: [
        ButtonComponent,
        SimpleListItemComponent,
        SelectableListComponent,
        DropdownFilterComponent,
        DropdownFilterWcagComponent,
        IconButtonComponent,
        IconComponent,
        RadioGroupComponent,
        SelectableItemsComponent,
        SelectableItemComponent,
        SelectableListItemComponent,
        SelectableBlockWrapperComponent,
        DatepickerComponent,
        DatepickerFeatureComponent,
        CalendarComponent,
        CalendarWeekComponent,
        CalendarDayComponent,
        CalendarControlsComponent,
        BlockRowComponent,
        MatchHeightDirective,
        ArrowDownSeparatorComponent,
        VerticalOrSeparatorComponent,
        BlockRowItemsComponent,
        BlockRowAreaComponent,
        BlockRowAreaResponsiveComponent,
        TabsComponent,
        TabItemComponent,
        BlockFullWidthComponent,
        PageContentWrapperComponent,
        LanguageSelectorComponent,
        ModalComponent,
        ModalWrapperComponent,
        LoginComponent,
        LoginSocialComponent,
        RegisterComponent,
        RegisterSocialComponent,
        ProgressComponent,
        DatePeriodSelectorComponent,
        AccountNavigationComponent,
        SelectableButtonComponent,
        DialogComponent,
        SelectableCheckableItemComponent,
        BlockItemsThreeComponent,
        BlockItemsTwoComponent,
        AddCardFormComponent,
        BlockLeftSidePanelComponent,
        BlockRightSidePanelComponent,
        BlockFullWidthFormsComponent,
        TableRowComponent,
        CardActionsSelectorComponent,
        TableComponent,
        TableHeaderComponent,
        DialogBottomComponent,
        DropdownComponent,
        DropdownDefaultItemComponent,
        DropdownRelatedCardItemComponent,
        AutofocusDirective,
        FocusInvalidInputDirective,
        MswComponent,
        MswTileComponent,
        NavigationBarComponent,
        BlockFullWidthMessageComponent,
        ProgressV2Component,
        InputFloatingLabelComponent,
        InputFloatingLabelErrorComponent,
        TermsModalContentComponent,
        TermsAndConditionsBlockComponent,
        HeaderMenuItemComponent,
        AccountActionsSelectorComponent,
        CarouselComponent,
        CarouselItemDirective,
        CarouselItemElement,
        TranslatedLinkHandlerDirective,
        RidangoScrollIntoViewDirective
    ],
    exports: [
        ButtonComponent,
        SimpleListItemComponent,
        SelectableListComponent,
        DropdownFilterComponent,
        DropdownFilterWcagComponent,
        IconButtonComponent,
        IconComponent,
        RadioGroupComponent,
        SelectableItemsComponent,
        SelectableItemComponent,
        SelectableListItemComponent,
        DatepickerComponent,
        DatepickerFeatureComponent,
        CalendarComponent,
        BlockRowComponent,
        MatchHeightDirective,
        ArrowDownSeparatorComponent,
        VerticalOrSeparatorComponent,
        BlockRowItemsComponent,
        BlockRowAreaComponent,
        BlockRowAreaResponsiveComponent,
        TabsComponent,
        BlockFullWidthComponent,
        PageContentWrapperComponent,
        LanguageSelectorComponent,
        ModalComponent,
        LoginComponent,
        LoginSocialComponent,
        RegisterComponent,
        RegisterSocialComponent,
        ProgressComponent,
        DatePeriodSelectorComponent,
        AccountNavigationComponent,
        SelectableButtonComponent,
        DialogComponent,
        SelectableCheckableItemComponent,
        SelectableBlockWrapperComponent,
        BlockItemsThreeComponent,
        BlockItemsTwoComponent,
        AddCardFormComponent,
        BlockLeftSidePanelComponent,
        BlockRightSidePanelComponent,
        BlockFullWidthFormsComponent,
        TableRowComponent,
        CardActionsSelectorComponent,
        TableComponent,
        TableHeaderComponent,
        DialogBottomComponent,
        DropdownComponent,
        MswComponent,
        AutofocusDirective,
        FocusInvalidInputDirective,
        NavigationBarComponent,
        BlockFullWidthMessageComponent,
        ProgressV2Component,
        InputFloatingLabelComponent,
        InputFloatingLabelErrorComponent,
        FormFieldModule,
        TermsModalContentComponent,
        TermsAndConditionsBlockComponent,
        HeaderMenuItemComponent,
        AccountActionsSelectorComponent,
        A11yModule,
        CarouselComponent,
        CarouselItemDirective,
        CarouselItemElement,
        MatIconModule,
        TranslatedLinkHandlerDirective,
        RidangoScrollIntoViewDirective
    ],
    entryComponents: [ModalWrapperComponent]
})
export class CoreUiModule {}
